import _slicedToArray from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { getArcObject } from '../../../shape/utils';
import { isCircular, isRadial } from '../../../utils/coordinate';
import { maybePercentage } from '../../../utils/helper';
import { mid } from '../../../utils/vector';
export function inferNonCircularStyle(position, points, value, coordinate) {
  var bounds = value.bounds;
  var _bounds = _slicedToArray(bounds, 2),
    _bounds$ = _slicedToArray(_bounds[0], 2),
    x0 = _bounds$[0],
    y0 = _bounds$[1],
    _bounds$2 = _slicedToArray(_bounds[1], 2),
    x1 = _bounds$2[0],
    y1 = _bounds$2[1];
  var w = x1 - x0;
  var h = y1 - y0;
  var xy = function xy(options) {
    var ox = options.x,
      oy = options.y;
    var px = maybePercentage(value.x, w);
    var py = maybePercentage(value.y, h);
    return Object.assign(Object.assign({}, options), {
      x: (px || ox) + x0,
      y: (py || oy) + y0
    });
  };
  // 4 direction.
  if (position === 'left') return xy({
    x: 0,
    y: h / 2,
    textAnchor: 'start',
    textBaseline: 'middle'
  });
  if (position === 'right') return xy({
    x: w,
    y: h / 2,
    textAnchor: 'end',
    textBaseline: 'middle'
  });
  if (position === 'top') return xy({
    x: w / 2,
    y: 0,
    textAnchor: 'center',
    textBaseline: 'top'
  });
  if (position === 'bottom') return xy({
    x: w / 2,
    y: h,
    textAnchor: 'center',
    textBaseline: 'bottom'
  });
  // 4 corner position.
  if (position === 'top-left') return xy({
    x: 0,
    y: 0,
    textAnchor: 'start',
    textBaseline: 'top'
  });
  if (position === 'top-right') return xy({
    x: w,
    y: 0,
    textAnchor: 'end',
    textBaseline: 'top'
  });
  if (position === 'bottom-left') return xy({
    x: 0,
    y: h,
    textAnchor: 'start',
    textBaseline: 'bottom'
  });
  if (position === 'bottom-right') return xy({
    x: w,
    y: h,
    textAnchor: 'end',
    textBaseline: 'bottom'
  });
  // default return 'inside'
  return xy({
    x: w / 2,
    y: h / 2,
    textAnchor: 'center',
    textBaseline: 'middle'
  });
}
export function inferRadialStyle(position, points, value, coordinate) {
  var y = value.y,
    y1 = value.y1,
    autoRotate = value.autoRotate,
    rotateToAlignArc = value.rotateToAlignArc;
  var center = coordinate.getCenter();
  var arcObject = getArcObject(coordinate, points, [y, y1]);
  var innerRadius = arcObject.innerRadius,
    outerRadius = arcObject.outerRadius,
    startAngle = arcObject.startAngle,
    endAngle = arcObject.endAngle;
  var angle = position === 'inside' ? (startAngle + endAngle) / 2 : endAngle;
  var rotate = inferRotation(angle, autoRotate, rotateToAlignArc);
  var point = function () {
    var _points = _slicedToArray(points, 2),
      p0 = _points[0],
      p1 = _points[1];
    var radius = innerRadius + (outerRadius - innerRadius) * 0.5;
    var _ref = position === 'inside' ? pointOfArc(center, angle, radius) : mid(p0, p1),
      _ref2 = _slicedToArray(_ref, 2),
      x = _ref2[0],
      y = _ref2[1];
    return {
      x: x,
      y: y
    };
  }();
  return Object.assign(Object.assign({}, point), {
    textAlign: position === 'inside' ? 'center' : 'start',
    textBaseline: 'middle',
    rotate: rotate
  });
}
export function pointOfArc(center, angle, radius) {
  return [center[0] + Math.sin(angle) * radius, center[1] - Math.cos(angle) * radius];
}
export function inferRotation(angle, autoRotate, rotateToAlignArc) {
  if (!autoRotate) return 0;
  var append = rotateToAlignArc ? 0 : Math.sin(angle) < 0 ? 90 : -90;
  return angle / Math.PI * 180 + append;
}
function inferInnerCircularStyle(position, points, value, coordinate) {
  var y = value.y,
    y1 = value.y1,
    autoRotate = value.autoRotate,
    rotateToAlignArc = value.rotateToAlignArc,
    _value$radius = value.radius,
    radiusRatio = _value$radius === void 0 ? 0.5 : _value$radius,
    _value$offset = value.offset,
    offset = _value$offset === void 0 ? 0 : _value$offset;
  var arcObject = getArcObject(coordinate, points, [y, y1]);
  var startAngle = arcObject.startAngle,
    endAngle = arcObject.endAngle;
  var center = coordinate.getCenter();
  var angle = (startAngle + endAngle) / 2;
  var rotate = inferRotation(angle, autoRotate, rotateToAlignArc);
  var textStyle = {
    textAlign: 'center',
    textBaseline: 'middle',
    rotate: rotate
  };
  var innerRadius = arcObject.innerRadius,
    outerRadius = arcObject.outerRadius;
  var r0 = innerRadius + (outerRadius - innerRadius) * radiusRatio;
  var r1 = r0 + offset;
  var _pointOfArc = pointOfArc(center, angle, r1),
    _pointOfArc2 = _slicedToArray(_pointOfArc, 2),
    x0 = _pointOfArc2[0],
    y0 = _pointOfArc2[1];
  return Object.assign({
    x: x0,
    y: y0
  }, textStyle);
}
// Set to null will not be set with default value as below.
// const { x = 0 } = options;
function maybeUndefined(d) {
  return d === undefined ? null : d;
}
export function inferIdentityStyle(position, points, value, coordinate) {
  var bounds = value.bounds;
  var _bounds2 = _slicedToArray(bounds, 1),
    p = _bounds2[0];
  return {
    x: maybeUndefined(p[0]),
    y: maybeUndefined(p[1])
  };
}
export function getDefaultStyle(position, points, value, coordinate) {
  var bounds = value.bounds; // When bounds.length = 1
  // For series mark, such as line and area.
  // The bounds for text is defined with only one point.
  // Use this point as the label position.
  if (bounds.length === 1) {
    return inferIdentityStyle(position, points, value, coordinate);
  }
  var inferDefaultStyle = isRadial(coordinate) ? inferRadialStyle : isCircular(coordinate) ? inferInnerCircularStyle : inferNonCircularStyle;
  return inferDefaultStyle(position, points, value, coordinate);
}